import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { CNPJ, CPF, PHONE } from "components/NumberFormat";
import Input from "components/ReduxForm/Input";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import renderCheckBoxField from "shared/components/form/CheckBox";
import renderDatePickerField from "shared/components/form/DatePicker";
import ls from "Localization";

const FormTwo = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormTwoSubmit,
		change
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("expositor_form");

	const loading = selector(state, "loading");

	const type = selector(state, "type");

	const feapaes = selector(state, "feapaes");
	const apae = selector(state, "apae");
	const provincial = selector(state, "provincial");
	const region = selector(state, "region");
	const local = selector(state, "local");
	const other = selector(state, "other");

	const handleNextClick = e => {
		e.preventDefault();
		handleSubmit(onFormTwoSubmit);
	};

	return (
		<form className="form" onSubmit={handleNextClick}>
			<div className="form__form-group">
				<div className="flex-center">
					<h3 className="account__title">{ls[type]}</h3>
				</div>
				{type === "exhibitor" && (
					<>
						<span className="form__form-group-label">Empresa</span>
						<div className="form__form-group-field">
							<Field
								name="companyName"
								type="text"
								placeholder="Nome da empresa"
								autoFocus={true}
								component={Input}
								key="companyName"
							/>
						</div>
						<br />
						<span className="form__form-group-label">CNPJ</span>
						<div className="form__form-group-field">
							<Field
								name="cnpj"
								type="text"
								placeholder="CNPJ da empresa"
								component={CNPJ}
							/>
						</div>
					</>
				)}
				<br />
				<div style={{ display: "flex" }}>
					<div style={{ flex: 1, marginRight: 4 }}>
						<span className="form__form-group-label">Nome</span>
						<div className="form__form-group-field">
							<Field
								name="name"
								type="text"
								placeholder="Seu Nome"
								autoFocus={true}
								component={Input}
								key="firstName"
							/>
						</div>
					</div>
					<div style={{ flex: 1, marginLeft: 4 }}>
						<span className="form__form-group-label">Sobrenome</span>
						<div className="form__form-group-field">
							<Field
								name="lastname"
								type="text"
								placeholder="Seu Sobrenome"
								component={Input}
								key="lastName"
							/>
						</div>
					</div>
				</div>
				<br />
				<div style={{ display: "flex" }}>
					<div style={{ flex: 1, marginRight: 4 }}>
						<span className="form__form-group-label">E-mail</span>
						<div className="form__form-group-field">
							<Field
								name="email"
								type="email"
								placeholder="Seu e-mail"
								component={Input}
								key="email"
							/>
						</div>
					</div>
					<div style={{ flex: 1, marginLeft: 4 }}>
						<span className="form__form-group-label">WhatsApp</span>
						<div className="form__form-group-field">
							<Field
								name="phone"
								type="text"
								placeholder="Seu WhatsApp"
								component={PHONE}
							/>
						</div>
					</div>
				</div>
				<br />
				<div style={{ display: "flex" }}>
					<div style={{ flex: 1, marginRight: 4 }}>
						<span className="form__form-group-label">CPF</span>
						<div className="form__form-group-field">
							<Field
								name="cpf"
								type="text"
								placeholder="Seu CPF"
								component={CPF}
							/>
						</div>
					</div>
					<div style={{ flex: 1, marginLeft: 4 }}>
						<span className="form__form-group-label">Data de Nascimento</span>
						<div className="form__form-group-field">
							<Field
								name="birthDate"
								placeholder="Data de Nascimento"
								component={renderDatePickerField}
							/>
						</div>
					</div>
				</div>
				<br />
				<div style={{ display: "flex" }}>
					<div style={{ flex: 1, marginRight: 4 }}>
						<span className="form__form-group-label">Local de Nascimento</span>
						<div className="form__form-group-field">
							<Field
								name="birthPlace"
								type="text"
								placeholder="Local de Nascimento"
								component={Input}
								key="birthPlace"
							/>
						</div>
					</div>

					{["exhibitor", "speaker"].includes(type) && (
						<div style={{ flex: 1, marginLeft: 4 }}>
							<span className="form__form-group-label">Área de atuação:</span>
							<div className="form__form-group-field">
								<Field
									name="profession"
									component={Input}
									type="text"
									placeholder="Área de atuação"
								/>
							</div>
							<br />
						</div>
					)}
				</div>

				<br />

				{["defender"].includes(type) && (
					<>
						<span className="form__form-group-label">Selecione uma opção</span>
						<br />
						<div
							className="form__form-group-field"
							style={{ justifyContent: "space-around" }}
						>
							<Field
								name="provincial"
								component={renderCheckBoxField}
								type="text"
								label="Estadual"
								onChange={() => {
									change("region", false);
									change("local", false);
								}}
							/>
							<Field
								name="region"
								component={renderCheckBoxField}
								type="text"
								label="Regional"
								onChange={() => {
									change("provincial", false);
									change("local", false);
								}}
							/>
							<Field
								name="local"
								component={renderCheckBoxField}
								type="text"
								label="Local"
								onChange={() => {
									change("provincial", false);
									change("region", false);
								}}
							/>
						</div>
					</>
				)}

				{["director"].includes(type) && (
					<>
						<span className="form__form-group-label">Selecione uma opção</span>
						<br />
						<div
							className="form__form-group-field"
							style={{ justifyContent: "space-around" }}
						>
							<Field
								name="feapaes"
								component={renderCheckBoxField}
								type="text"
								label="FEAPAES"
								onChange={() => {
									change("apae", false);
								}}
							/>
							<Field
								name="apae"
								component={renderCheckBoxField}
								type="text"
								label="APAE"
								onChange={() => {
									change("feapaes", false);
								}}
							/>
						</div>
						{(feapaes || apae) && (
							<>
								<span className="form__form-group-label">Cargo</span>
								<div className="form__form-group-field">
									<Field
										name="profession"
										component={Input}
										type="text"
										placeholder="Seu cargo na instituição"
									/>
								</div>
								<br />
							</>
						)}
					</>
				)}

				{["coordinator"].includes(type) && (
					<>
						<span className="form__form-group-label">Selecione uma opção</span>
						<br />
						<div
							className="form__form-group-field"
							style={{ justifyContent: "space-around" }}
						>
							<Field
								name="provincial"
								component={renderCheckBoxField}
								type="text"
								label="Estadual"
							/>
							<Field
								name="region"
								component={renderCheckBoxField}
								type="text"
								label="Regional"
							/>
							<Field
								name="local"
								component={renderCheckBoxField}
								type="text"
								label="Local"
							/>
						</div>
						{(provincial || region || local) && (
							<>
								{provincial && (
									<>
										<div style={{ display: "flex" }}>
											<div style={{ flex: 1, marginRight: 4 }}>
												<span className="form__form-group-label">
													Nome da estadual:
												</span>
												<div className="form__form-group-field">
													<Field
														name="companyNameProvincial"
														component={Input}
														type="text"
														placeholder="Nome da estadual"
													/>
												</div>
											</div>
											<div style={{ flex: 1, marginLeft: 4 }}>
												<span className="form__form-group-label">
													Área de atuação:
												</span>
												<div className="form__form-group-field">
													<Field
														name="professionProvincial"
														component={Input}
														type="text"
														placeholder="Área de atuação"
													/>
												</div>
											</div>
											<br />
										</div>
										<br />
									</>
								)}

								{region && (
									<>
										<div style={{ display: "flex" }}>
											<div style={{ flex: 1, marginRight: 4 }}>
												<span className="form__form-group-label">
													Nome da regional:
												</span>
												<div className="form__form-group-field">
													<Field
														name="companyNameRegion"
														component={Input}
														type="text"
														placeholder="Nome da regional"
													/>
												</div>
											</div>
											<div style={{ flex: 1, marginLeft: 4 }}>
												<span className="form__form-group-label">
													Área de atuação:
												</span>
												<div className="form__form-group-field">
													<Field
														name="professionRegion"
														component={Input}
														type="text"
														placeholder="Área de atuação"
													/>
												</div>
											</div>
											<br />
										</div>
										<br />
									</>
								)}
								{local && (
									<>
										<div style={{ display: "flex" }}>
											<div style={{ flex: 1, marginRight: 4 }}>
												<span className="form__form-group-label">
													Nome da local:
												</span>
												<div className="form__form-group-field">
													<Field
														name="companyNameLocal"
														component={Input}
														type="text"
														placeholder="Nome da local"
													/>
												</div>
											</div>
											<div style={{ flex: 1, marginLeft: 4 }}>
												<span className="form__form-group-label">
													Área de atuação:
												</span>
												<div className="form__form-group-field">
													<Field
														name="professionLocal"
														component={Input}
														type="text"
														placeholder="Área de atuação"
													/>
												</div>
											</div>
										</div>
										<br />
									</>
								)}
							</>
						)}
					</>
				)}

				{["professional"].includes(type) && (
					<>
						<span className="form__form-group-label">Selecione uma opção</span>
						<br />
						<div
							className="form__form-group-field"
							style={{ justifyContent: "space-around" }}
						>
							<Field
								name="apae"
								component={renderCheckBoxField}
								type="text"
								label="APAE"
								onChange={() => {
									change("other", false);
								}}
							/>

							<Field
								name="other"
								component={renderCheckBoxField}
								type="text"
								label="Outro"
								onChange={() => {
									change("apae", false);
								}}
							/>
						</div>
						{other && (
							<>
								<span className="form__form-group-label">
									Nome da instituição que trabalha:
								</span>
								<div className="form__form-group-field">
									<Field
										name="companyName"
										component={Input}
										type="text"
										placeholder="Nome da instituição que trabalha"
									/>
								</div>
								<br />
							</>
						)}
						<span className="form__form-group-label">Função</span>
						<div className="form__form-group-field">
							<Field
								name="profession"
								component={Input}
								type="text"
								placeholder="Função na instituição"
							/>
						</div>
						<br />
					</>
				)}

				{["student"].includes(type) && (
					<>
						<br />
						<span className="form__form-group-label">
							Nome da instituição de ensino:
						</span>
						<div className="form__form-group-field">
							<Field
								name="companyName"
								component={Input}
								type="text"
								placeholder="Nome da instituição de ensino"
							/>
						</div>
						<br />
						<span className="form__form-group-label">
							Curso que está matriculado(a):
						</span>
						<div className="form__form-group-field">
							<Field
								name="profession"
								component={Input}
								type="text"
								placeholder="Curso que está matriculado(a)"
							/>
						</div>
						<br />
					</>
				)}

				{["guest"].includes(type) && (
					<>
						<br />
						<span className="form__form-group-label">Profissão:</span>
						<div className="form__form-group-field">
							<Field
								name="profession"
								component={Input}
								type="text"
								placeholder="Sua profissão"
							/>
						</div>
						<br />
					</>
				)}
			</div>
			<div className="account__btn__group">
				<button
					type="button"
					className="btn btn-primary account__btn account__btn--small"
					onClick={previousPage}
				>
					Voltar
				</button>
				<button
					type="submit"
					className="btn btn-primary account__btn account__btn--small"
					disabled={pristine || submitting}
				>
					{loading ? <Spinner type="grow" size="sm" color="dark" /> : "Próximo"}
				</button>
			</div>
		</form>
	);
};

export default reduxForm({
	form: "expositor_form",
	destroyOnUnmount: false, // Preserve form data
	forceUnregisterOnUnmount: true, // Unregister fields on unmount
	validate: v => validate(v, 2)
})(FormTwo);
